<template>
  <div id="app">
    <PixelBackground />
    <NavBar />
    <router-view />
    <Footer/>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import Footer from "@/components/AppFooter.vue";
import PixelBackground from "@/components/PixelBackground.vue";

export default {
  components: {Footer, NavBar, PixelBackground }
}
</script>

<style>
html {
  scroll-behavior: smooth;
  scroll-padding-top: 70px; /* offset voor fixed navbar */
}

#app {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-soft);
  /* geen eigen achtergrond: body is #0a0a0a en de fixed PixelBackground-canvas
     (z-index:-1) moet overal doorschemeren */
}

::selection {
  background: var(--accent);
  color: #0a0a0a;
}
</style>
